import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import Card4 from "../Images/Profiles/Aran.jpg";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function AranAhereza() {
  return (
    <div className="ne-page">
      <SEO
        title="Mr. Aran Ahereza - Security"
        description="Aran Ahereza holds a secondary education certificate at the ordinary level. Additionally, he holds a National certificate in Automotive Mechanics, which he acquired from UBTEB. His career journey has encompassed several roles. He previously worked with Electronics Network Services in Kampala and also served as a security officer for a group of families. He subsequently transitioned to his current position as a Security Officer at CIRCODU."
        keywords="Aran Ahereza, Security, CIRCODU, secondary education certificate, ordinary level, National certificate in Automotive Mechanics, UBTEB, Electronics Network Services, security officer"
        url="/aran-ahereza"
        image={Card4}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Mr. Aran Ahereza</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/the-staff-team">
              The Staff Team
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Mr. Aran Ahereza
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card4} alt="Mr. Aran Ahereza" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Mr. Aran Ahereza</h1>
                <p className="profile-card__role">Security</p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Aran Ahereza holds a secondary education certificate at the
                  ordinary level. Additionally, he holds a National certificate
                  in Automotive Mechanics, which he acquired from UBTEB. His
                  career journey has encompassed several roles. He previously
                  worked with Electronics Network Services in Kampala and also
                  served as a security officer for a group of families. He
                  subsequently transitioned to his current position as a
                  Security Officer at CIRCODU.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://ug.linkedin.com/company/centre-for-integrated-research-and-community-development-uganda-circodu"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/CIRCODU1/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://m.facebook.com/people/Allan-Kuz-Ahereza/100088951399209/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256761383838"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:aherezaallanovic486@gmail.com"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AranAhereza;
